import { createSlice } from '@reduxjs/toolkit'

const TorkOrderSlice = createSlice({
  name: 'TorkOrderSlice',
  initialState: [],
  reducers: {
    setTorkOrders(state, action) {
      return [...action.payload];
    },
    addTorkOrder(state, action) {
      if (state.some(o => o.id === action.payload.id)) return state;
      return [...state, action.payload];
    },
    addTorkOrders(state, action) {
      const incoming = action.payload.filter(o => !state.some(s => s.id === o.id));
      return [...state, ...incoming];
    },
    updateTorkOrder(state, action) {
      return state.map(o => o.id === action.payload.id ? action.payload : o);
    },
    removeTorkOrder(state, action) {
      return state.filter(o => o.id !== action.payload.id);
    }
  }
})

export const { setTorkOrders, addTorkOrder, addTorkOrders, updateTorkOrder, removeTorkOrder } = TorkOrderSlice.actions
export default TorkOrderSlice.reducer
